import TreasuryAccountHistory from "../components/treasury/TreasuryAccountHistory";

const TreasuryAccountHistoryPage = () => {
  return (
    <>
      <TreasuryAccountHistory />
    </>
  );
};

export default TreasuryAccountHistoryPage;
